import React from 'react';
import ReactDOM from 'react-dom';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import App from './App';

const cspNonce = (document.querySelector('meta[name="csp-nonce"]') as HTMLMetaElement | null)
  ?.getAttribute('content') ?? undefined;

// prepend: true is equivalent to StyledEngineProvider injectFirst — keeps MUI styles
// ordered before any app-level global styles so app styles can override MUI defaults.
const emotionCache = createCache({ key: 'css', prepend: true, nonce: cspNonce });

const rootElement = document.getElementById('root');
ReactDOM.render(
  <React.StrictMode>
    <CacheProvider value={emotionCache}>
      <App />
    </CacheProvider>
  </React.StrictMode>,
  rootElement
);
